/**
 * The card's action buttons: quiet icon buttons on the card's muted surface (the post's own
 * action bar uses filled buttons on the post), turning to the foreground colour on hover.
 */
export const RESOURCE_ACTION_BUTTON_CLASS_NAME = 'text-muted-foreground hover:text-foreground';
